// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading-state[data-v-2b491a19]{display:flex;justify-content:center;align-items:center;min-height:200px}", ""]);
// Exports
module.exports = exports;
